import type { AboutTranslations } from '../../types';

export const frAbout: AboutTranslations = {
  title: '\u00C0 propos de nous',
  subtitle: 'Innover pour un avenir durable.',
  header: {
    title: '\u00C0 propos de JH Heatsup',
    subtitle: 'Innover pour un avenir durable.',
  },
  history: {
    title: 'Notre histoire',
    desc: 'Fond\u00E9e en 2006, Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) a d\u00E9marr\u00E9 avec une vision simple : cr\u00E9er des solutions de chauffage et de refroidissement qui sont non seulement puissantes mais aussi respectueuses de l\'environnement. Situ\u00E9e dans le parc de haute technologie de Fuzhou, notre entreprise a \u00E9volu\u00E9 d\'une petite \u00E9quipe R&D \u00E0 un fabricant mondial.',
    timelineTitle: 'Les grandes étapes du chauffage infrarouge',
    timelineDesc: 'Six étapes retracent notre évolution, des premières gammes infrarouges aux solutions connectées et au chauffage rapide pour salles de bains.',
    milestones: [
      { year: '2013', title: 'Début de la production infrarouge', desc: 'Les radiateurs infrarouges lointains des séries 13A et 13B entrent en production.' },
      { year: '2015', title: 'Élargissement de la gamme', desc: 'Lancement des séries de radiateurs infrarouges lointains 14A/14B et 15A/15B.' },
      { year: '2017', title: 'Le chauffage adopte le Bluetooth', desc: 'La série JH13C est commercialisée avec un haut-parleur Bluetooth intégré.' },
      { year: '2018', title: 'Des solutions pour plus d’espaces', desc: 'Les plinthes chauffantes arrivent sur le marché et la production de radiateurs infrarouges pour salles de bains commence.' },
      { year: '2019', title: 'Chauffage intelligent avec Wi-Fi', desc: 'La série connectée 13W est lancée avec une fonction Wi-Fi intégrée.' },
      { year: '2021', title: 'Chaleur en cinq secondes', desc: 'Développement d’un radiateur de salle de bains à panneau de verre capable de chauffer en cinq secondes.' },
    ],
  },
  mission: {
    title: 'Notre mission',
  },
  quality: {
    title: 'Assurance qualit\u00E9',
    desc: 'Processus certifi\u00E9s ISO9001. Chaque radiateur est test\u00E9 avant de quitter notre usine.',
  },
  values: {
    title: 'Nos valeurs fondamentales',
    sustainability: {
      title: 'Durabilit\u00E9 & Innovation',
      desc: 'Innover dans les technologies \u00E9conomes en \u00E9nergie pour r\u00E9duire l\'empreinte carbone et maximiser l\'efficacit\u00E9 du chauffage.',
    },
    quality: {
      title: 'Qualit\u00E9 certifi\u00E9e',
      desc: 'Fabriqu\u00E9 dans des installations certifi\u00E9es ISO9001 et rigoureusement test\u00E9 pour garantir des performances premium.',
    },
    customerFirst: {
      title: 'Confiance et partenariat mondiaux',
      desc: 'Approuv\u00E9 par plus de 800 partenaires mondiaux dans plus de 100 pays, construisant des relations \u00E0 long terme gr\u00E2ce \u00E0 un service ax\u00E9 sur le client.',
    },
  },
  features: {
    title: 'Caract\u00E9ristiques des produits',
    fast: {
      title: 'Chauffage rapide',
      desc: '\u00C9chauffement rapide avec une technologie infrarouge efficace.',
    },
    energy: {
      title: '\u00C9conomies d\'\u00E9nergie',
      desc: 'Le contr\u00F4le intelligent aide \u00E0 r\u00E9duire les co\u00FBts de chauffage.',
    },
    healthy: {
      title: 'Confort sain',
      desc: 'Chaleur rayonnante sans dess\u00E9cher l\'air.',
    },
    safe: {
      title: 'S\u00E9curis\u00E9 & Fiable',
      desc: 'Multiples protections de s\u00E9curit\u00E9 pour une tranquillit\u00E9 d\'esprit.',
    },
  },
  companyProfile: {
    title: 'Profil de l\'entreprise',
    desc: 'Fujian Jinghui Environmental Technology Co., Ltd., anciennement connue sous le nom de Fujian Jinghui Environmental Technology Co., Ltd., a \u00E9t\u00E9 cr\u00E9\u00E9e en 2006 et a son si\u00E8ge \u00E0 Fuzhou, en Chine. Nous sommes une entreprise de haute technologie sp\u00E9cialis\u00E9e dans la recherche et la production de radiateurs \u00E0 rayonnement infrarouge lointain, adh\u00E9rant \u00E0 la philosophie d\'entreprise \u00AB S\'efforcer vers l\'excellence, cr\u00E9er la brillance ensemble \u00BB, engag\u00E9e \u00E0 fournir des solutions de chauffage efficaces, \u00E9conomes en \u00E9nergie, saines et confortables aux utilisateurs du monde entier.',
  },
  services: {
    title: 'Services professionnels',
    desc: 'Nous disposons d\'ing\u00E9nieurs techniques professionnels et d\'un personnel commercial exp\u00E9riment\u00E9 pour vous fournir des services de haute qualit\u00E9 dans les applications de refroidissement/chauffage industriel et commercial, tels que la fourniture de produits de haute qualit\u00E9 et de bonnes solutions pour la temp\u00E9rature confortable, l\'humidit\u00E9 et l\'air frais dans les ateliers d\'usines, les centres commerciaux, les gymnases, les caf\u00E9s, les serres, les espaces ext\u00E9rieurs et autres lieux.',
  },
  technology: {
    title: 'Technologie de pointe',
    desc: 'Nous appliquons la peinture nano-c\u00E9ramique aux radiateurs \u00E0 rayonnement infrarouge lointain, ce qui r\u00E9sout les probl\u00E8mes de d\u00E9coloration et de d\u00E9collement facile de la peinture des radiateurs traditionnels, rendant le rayonnement plus efficace et plus rapide. Notre technologie infrarouge lointain avanc\u00E9e fournit un chauffage rapide et une distribution de chaleur uniforme pour un environnement de vie chaleureux et confortable.',
    nanoCeramic: { title: 'Technologie nano-c\u00E9ramique', desc: 'Efficacit\u00E9 de rayonnement am\u00E9lior\u00E9e pour un chauffage plus rapide' },
    farInfrared: { title: 'Rayonnement infrarouge lointain', desc: 'Distribution de chaleur uniforme pour le confort' },
  },
  certifications: {
    title: 'Certifications & Brevets',
    desc: 'Nous avons obtenu plus de 32 brevets pour l\'apparence, les mod\u00E8les d\'utilit\u00E9 et les inventions. Nos produits sont conformes aux normes de s\u00E9curit\u00E9 internationales telles que CCC, ISO9001:2015, CE, CB, SAA, EMC, SASO, garantissant une assurance qualit\u00E9.',
  },
  clients: {
    title: 'Clients mondiaux',
    desc: 'Nos produits de radiateurs ont \u00E9t\u00E9 export\u00E9s vers plus de 100 pays et r\u00E9gions dans le monde, approuv\u00E9s par les utilisateurs mondiaux.',
    export: 'Exportation vers plus de 100 pays et r\u00E9gions',
    agents: 'Plus de 800 agents internationaux',
    trusted: 'Approuv\u00E9 par les utilisateurs du monde entier',
    showcaseTitle: 'La confiance de partenaires du monde entier',
    showcaseDesc: 'Lors de salons internationaux, nous rencontrons des distributeurs, des acheteurs de projets et des professionnels du secteur venus du monde entier. Ces échanges nous permettent de comprendre les besoins locaux, de présenter nos dernières solutions de chauffage infrarouge et de bâtir des partenariats durables grâce à des produits fiables, une qualité constante et un service réactif.',
  },
  manufacturing: {
    title: 'Capacit\u00E9 de fabrication',
    desc: 'Nous disposons d\'un atelier de production de 8 000 m\u00E8tres carr\u00E9s avec plus de 150 ing\u00E9nieurs techniques et ouvriers qualifi\u00E9s, avec une capacit\u00E9 de production mensuelle de plus de 10 000 produits de radiateurs. Nous avons la capacit\u00E9 de compl\u00E9ter chaque commande \u00E0 temps avec qualit\u00E9 et quantit\u00E9.',
    workshopArea: 'Surface de l\'atelier',
    engineersWorkers: 'Ing\u00E9nieurs & Ouvriers',
    monthlyCapacity: 'Capacit\u00E9 mensuelle',
    patents: 'Brevets',
  },
  ceo: {
    title: 'Notre fondatrice',
    name: 'Mme Huang Xuefang',
    role: 'Fondatrice',
    desc: 'Mme Huang Xuefang est l\'une des premi\u00E8res chercheuses et conceptrices de radiateurs infrarouges en Chine. En 2003, elle a travaill\u00E9 avec un groupe de partenaires passionn\u00E9s par la technologie de chauffage pour d\u00E9velopper et concevoir des produits \u00E9vaporatifs. En 2006, elle a fond\u00E9 Fujian Jinghui Environmental Technology Co., Ltd. En 2011, elle a dirig\u00E9 l\'\u00E9quipe R&D pour concevoir des radiateurs \u00E0 rayonnement infrarouge lointain de type panneau, int\u00E9grant habilement des contr\u00F4les intelligents, des haut-parleurs Bluetooth et le Wi-Fi dans les radiateurs, en faisant non seulement des appareils de chauffage mais aussi un style de vie. Chaque d\u00E9tail de conception refl\u00E8te sa fusion de l\'esth\u00E9tique occidentale avec le charme oriental, donnant aux produits une vitalit\u00E9 vivante.',
    quote: '\u00AB Nous nous engageons \u00E0 cr\u00E9er un monde plus vert et plus chaud gr\u00E2ce \u00E0 la technologie. \u00BB',
  },
  applications: {
    title: 'Sc\u00E9narios d\'application',
    desc: 'Nos radiateurs infrarouges sont largement utilis\u00E9s dans divers sc\u00E9narios, vous fournissant des solutions de chauffage compl\u00E8tes',
    restaurant: {
      title: 'Restaurant',
      desc: '',
      icon: 'Utensils',
    },
    livingRoom: {
      title: 'Salon',
      desc: '',
      icon: 'Sofa',
    },
    office: {
      title: 'Bureau',
      desc: '',
      icon: 'Building',
    },
    patio: {
      title: 'Terrasse',
      desc: '',
      icon: 'Sun',
    },
    sauna: {
      title: 'Sauna',
      desc: '',
      icon: 'Flame',
    },
    garage: {
      title: 'Garage',
      desc: '',
      icon: 'Warehouse',
    },
    balcony: {
      title: 'Salle de sport',
      desc: '',
      icon: 'Dumbbell',
    },
    entertainment: {
      title: 'Salle de loisirs',
      desc: '',
      icon: 'Gamepad2',
    },
  },
};
